import { ChevronLeft, ChevronRight } from "lucide-react";

import { Button } from "@/components/ui/button";

interface AiHelpCardNextPreviousProps {
  handlePrevious: () => void;
  handleNext: () => void;
  currentIndex: number;
  historyLength: number;
  disabled?: boolean;
}

export function AiHelpCardNextPrevious({
  handlePrevious,
  handleNext,
  currentIndex,
  historyLength,
  disabled = false,
}: Readonly<AiHelpCardNextPreviousProps>) {
  return (
    <div className="flex justify-between">
      <Button
        onClick={handlePrevious}
        disabled={disabled || currentIndex === 0}
        variant="link"
        size="sm"
      >
        <ChevronLeft
          size={16}
          className={currentIndex === 0 ? "text-gray-400" : "text-gray-900"}
        />
      </Button>
      <Button
        onClick={handleNext}
        disabled={disabled || currentIndex === historyLength - 1}
        variant="link"
        size="sm"
      >
        <ChevronRight
          size={16}
          className={
            currentIndex === historyLength - 1
              ? "text-gray-400"
              : "text-gray-900"
          }
        />
      </Button>
    </div>
  );
}
